import type { FilterConsistencyState } from '../engine/filterGroupConsistency';

let sharedFilterState: FilterConsistencyState | null = null;

export const getSharedFilterState = (): FilterConsistencyState | null =>
  sharedFilterState;

export const setSharedFilterState = (next: FilterConsistencyState): void => {
  if (sharedFilterState === next) return;
  sharedFilterState = next;
};

/**Test-only: drop all shared state */
export const __resetSharedFilterStateForTests = (): void => {
  sharedFilterState = null;
};
